module.exports = __webpack_public_path__ + "img/16_81.34b18ebb.png";